import { render } from "./CollectionSelect.vue?vue&type=template&id=1d314ef2"
import script from "./CollectionSelect.vue?vue&type=script&lang=js"
export * from "./CollectionSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__